import { render, staticRenderFns } from "./videoContainer.vue?vue&type=template&id=0aaf72a4&scoped=true&lang=html&"
import script from "./videoContainer.vue?vue&type=script&lang=js&"
export * from "./videoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf72a4",
  null
  
)

export default component.exports